import { FC, useMemo } from "react";
import ReactApexChart from "react-apexcharts";
import { ApexOptions } from "apexcharts";

interface CommissionDailyChartProps {
  data: {
    day: number;
    month: number;
    year: number;
    total_commission: number;
  }[];
  startDate?: Date | null;
  endDate?: Date | null;
}

const CommissionDailyChart: FC<CommissionDailyChartProps> = ({ data, startDate, endDate }) => {
  const filteredData = useMemo(() => {
    if (!startDate && !endDate) {
      return data.slice(-14);
    }

    return data.filter(item => {
      const itemDate = new Date(item.year, item.month - 1, item.day);

      if (startDate && endDate) {
        return itemDate >= startDate && itemDate <= endDate;
      } else if (startDate) {
        return itemDate >= startDate;
      } else if (endDate) {
        return itemDate <= endDate;
      }
      
      return true;
    });
  }, [data, startDate, endDate]);

  const lastDays = filteredData.length > 0 ? filteredData : data.slice(-14);
  
  const categories = lastDays.map(item => `${item.day}/${item.month}/${item.year}`);
  const seriesData = lastDays.map(item => item.total_commission);

  const options: ApexOptions = {
    chart: {
      type: "area",
      height: 350,
      toolbar: {
        show: true,
      },
      zoom: {
        enabled: true,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
      width: 2,
    },
    title: {
      text: "Comisiones diarias",
      align: "left",
      style: {
        fontSize: "16px",
        fontWeight: "600",
      },
    },
    xaxis: {
      categories: categories,
      labels: {
        style: {
          fontSize: "12px",
        },
        rotate: -45,
      },
    },
    yaxis: {
      labels: {
        formatter: function (value) {
          return `$${value.toLocaleString("es-MX")}`;
        },
      },
    },
    tooltip: {
      y: {
        formatter: function (value) {
          return `$${value.toLocaleString("es-MX", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`;
        },
      },
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.7,
        opacityTo: 0.3,
        stops: [0, 90, 100],
      },
    },
    colors: ["#00D4AA"],
  };

  const series = [
    {
      name: "Comisión",
      data: seriesData,
    },
  ];

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <ReactApexChart
        options={options}
        series={series}
        type="area"
        height={250}
      />
    </div>
  );
};

export default CommissionDailyChart;
